<div class="zoom-wrapper">
  <button class="zoom-btn minus" (click)="zoomOut()">−</button>

  <div
    class="zoom-container"
    #container
    (mousedown)="startDrag($event)"
    (mousemove)="onDrag($event)"
    (mouseup)="stopDrag()"
    (mouseleave)="stopDrag()"

    (touchstart)="onTouchStart($event)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd($event)"
  >
    <img
      [src]="src"
      [alt]="alt"
      class="zoom-image"
      [style.transform]="transform"
      draggable="false"
    />
  </div>

  <button class="zoom-btn plus" (click)="zoomIn()">+</button>
</div>
